export function getdata() {
	var obj = {
		searchlist: [{
				prop: "danjh",
				label: '单据号',
				type: "input"
			}, {
				prop: "faphm",
				label: '发票号码',
				type: "input",
				isNumber: true
			}, {
				prop: "tedywlx",
				label: '特殊业务',
				type: "select",
				selectval: [{
						label: "成品油",
						value: "01"
					},
					{
						label: "稀土",
						value: "02"
					},
					{
						label: "建筑服务",
						value: "03"
					},
					{
						label: "不动产经营租赁",
						value: "06"
					},
					{
						label: "机动车",
						value: "13"
					},
				]
			},
			{
				prop: "danjzt",
				label: '单据状态',
				type: "select",
				selectval: [
					{
						value: '3',
						label: '开票中'
					},
					{
						value: '4',
						label: '已开票'
					},
					{
						value: '5',
						label: '已作废'
					},
					{
						value: '6',
						label: '已红冲'
					}
				]
			},

			{
				prop: "danjly",
				label: '单据来源',
				type: "select",
				selectval: [{
						value: '1',
						label: '文件导入'
					},
					{
						value: '2',
						label: '手工录入'
					},
					{
						value: '3',
						label: '客户接口'
					},
					{
						value: '6',
						label: '扫码开票'
					},
					{
						value: '7',
						label: '红冲重开'
					},
					{
						value: '8',
						label: '作废重开'
					},
				]
			},
			{
				prop: "danjrq",
				label: '单据日期',
				type: "date",
				valueformat: "yyyyMMdd"
			}, {
				prop: "jiashj",
				label: '价税合计',
				type: "input",
				isNumber: true
			}, {
				prop: "jine",
				label: '金额',
				type: "input",
				isNumber: true
			}, {
				prop: "shuie",
				label: '税额',
				type: "input",
				isNumber: true
			}, {
				prop: "kaiprq",
				label: '开票日期',
				type: "date",
				valueformat: "yyyyMMdd"
			},
			{
				prop: "goufmc",
				label: '购方名称',
				type: "input"
			},
			{
				prop: "faplxdm",
				label: '发票类型',
				type: "select",
				selectval: [{
						value: '004',
						label: '专票'
					},
					{
						value: '007',
						label: '普票'
					},
					{
						value: '026',
						label: '电子发票(普票)'
					},
					{
						value: '028',
						label: '电子发票(专票)'
					}
				]
			},
		],
		searchdata: {
			"danjly": "",
			"danjrq": [],
			"jiashj": "",
			"danjh": "",
			"faphm": "",
			"tedywlx": "",
			"danjzt": "",
			"shuie": "",
			"jine": "",
			"goufmc": "",
			"kaiprq": []
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		jgData: [{
				title: "单据号",
				prop: "danjh",
				width: "100",
				issort: true
			},
			{
				title: "单据状态",
				prop: "fapzt",
				width: "80",
				custom: true,
				issort: true
			}, {
				title: "发票来源",
				prop: "faply",
				width: "80",
				custom: true,
				issort: true
			}, {
				title: "发票类型",
				prop: "faplxdm",
				width: "80",
				custom: true,
				issort: true
			},
			{
				title: "发票号码",
				prop: "faphm",
				width: "80",
				issort: true
			},
			{
				title: "开票日期",
				prop: "kaiprq",
				width: "120"
			},
			{
				title: "特殊业务",
				prop: "tedywlx",
				width: "80",
				custom: true,
				issort: true
			},
			{
				title: "购方名称",
				prop: "goufmc",
				width: "160",
				align: "left",
				issort: true
			},
			{
				title: "金额",
				prop: "hejje",
				width: "80",
				align: "right",
				AmountFormat: true,
				issort: true
			}, {
				title: "税额",
				prop: "hejse",
				width: "80",
				align: "right",
				AmountFormat: true,
				issort: true
			}
		],
		headData: [{
				title: "文件名",
				prop: "fileName",
				width: "250",
			},
			{
				title: "获取发票张数",
				prop: "detected",
				width: "100",
			}, {
				title: "成功张数",
				prop: "success",
				width: "70",
			}, {
				title: "失败张数",
				prop: "fail",
				width: "70",
			},
			{
				title: "任务状态",
				prop: "taskStatus",
				width: "70",
				custom: true,
			},
			{
				title: "导入开始时间",
				prop: "taskStartTime",
				width: "180",
			},
			{
				title: "导入完成时间",
				prop: "taskEndTime",
				width: "180",
			},
			{
				title: "操作人",
				prop: "userName",
				width: "200",
			}
		],
		headData2: [{
			title: "文件名",
			prop: "fileName",
			width: "250",
		},
		{
			title: "上传文件数",
			prop: "detected",
			width: "100",
		}, {
			title: "成功张数",
			prop: "success",
			width: "70",
		}, {
			title: "失败张数",
			prop: "fail",
			width: "70",
		},
		{
			title: "任务状态",
			prop: "taskStatus",
			width: "70",
			custom: true,
		},
		{
			title: "导入开始时间",
			prop: "taskStartTime",
			width: "180",
		},
		{
			title: "导入完成时间",
			prop: "taskEndTime",
			width: "180",
		},
		{
			title: "操作人",
			prop: "userName",
			width: "200",
		}
	]
	}
	return obj
}
